import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.ATF],
  strings: [
    'AVOD_DP_season_selector',
    'DV_DP_Watchlist_toggle_label',
    'DV_DP_WL_removeMovie',
    'DV_DP_WL_removeTv',
    'DV_DP_WL_addMovie',
    'DV_DP_WL_addTv',
    'DV_DP_WL_addTvProcessing',
    'DV_DP_WL_removeTvProcessing',
    'AVOD_WL_error_msg',
    'DV_DP_WL_watchlist',
  ] as const,
}
